import React, { useCallback, useEffect, useMemo, useState } from 'react';
import LoaderComponent from 'features/shared/layouts/main/ui/components/loader';
import { useClickStreamContext } from '../shared/ClickStream';
import Spacer from '../shared/Spacer';
import useUserData from 'hooks/useUserData';
import { Container, Header, Plate, Text } from 'features/shared/ui/Page';
import YearSelector from 'features/shared/ui/YearSelector';
import { useGratitudesContext } from './GratitudesContext';
import { Space } from '@gr-monorepo/common/ui';
import useGratitudeCheck from 'hooks/useGratitudeCheck';
import { useGratitudes, monthes, sectionKeys } from './useGratitudes';
import ItemsRow from './ItemsRow';
import { sections } from './GratitudesPlateTemplates';
import { GratitudesPlate } from './GratitudesPlate';
import { Section } from '@gr-monorepo/common/models/gratitude';

export const getEducationYearOption = (years: string[]) =>
  [...years]
    .sort()
    .reverse()
    .map((el) => ({ id: el.replace('#', '/'), label: el.replace('#', '-') }));

const Gratitudes = () => {
  const userData = useUserData();
  const userType = userData!.userType;
  const { years, loaded } = useGratitudeCheck();
  const educationYears = getEducationYearOption(years.map((el) => el.year));
  const { setVisited, lastVisitedPage } = useGratitudesContext();
  const [lastVisited] = useState(lastVisitedPage);
  const { bySectionAndMonth, currentYear, setCurrentYear, loaded: listLoaded } = useGratitudes(lastVisited);
  const { logPageEvent } = useClickStreamContext();
  const isMunicipality = userData?.isMunicipality || userData?.isCityDistrict || false;

  useEffect(() => {
    if (loaded) {
      setCurrentYear(educationYears[0]);
    }
  }, [loaded]);

  useEffect(() => {
    setVisited();
  }, []);

  return (
    <Container>
      <Header>
        Портфолио
        <Spacer size={24} style={{ display: 'inline-block' }} />
        {currentYear && (
          <YearSelector
            values={educationYears}
            value={currentYear}
            handleChange={(value) => {
              setCurrentYear(value);
              logPageEvent?.({
                eventType: 'gratitude_change_year',
                eventInfo: `Благодарности: Клик по табу с выбором уч. года года ${value.label}`,
              });
            }}
          ></YearSelector>
        )}
      </Header>

      <Space size={32} axis="vertical" />
      {(isMunicipality || !!bySectionAndMonth[Section.school]) && (
        <>
          <GratitudesPlate
            section={Section.school}
            gratitudes={bySectionAndMonth[Section.school]}
            loading={!listLoaded}
            isMunicipality={isMunicipality}
          />
          <Space axis="vertical" size={40} />
        </>
      )}

      {!!bySectionAndMonth[Section.municipality] && (
        <GratitudesPlate
          section={Section.municipality}
          gratitudes={bySectionAndMonth[Section.municipality]}
          loading={!listLoaded}
          isMunicipality={isMunicipality}
        />
      )}
    </Container>
  );
};

export default Gratitudes;
